module.exports = __webpack_public_path__ + "static/img/pfwa-award.3e6a5e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pfwa-award.jpg
// module id = 9MdC
// module chunks = 1